import { useQueryClient } from '@tanstack/react-query'
import { ApiResponse } from '../../../types/api'
import { UserConsumeWrongRoundSummaryRequest } from '../../../types/user'
import { useApiPostMutation } from '../useApi'

export const useUserConsumeWrongRoundSummary = () => {
  const queryClient = useQueryClient()
  const mutation = useApiPostMutation<ApiResponse, UserConsumeWrongRoundSummaryRequest>()

  return {
    ...mutation,
    mutateAsync: async (data: UserConsumeWrongRoundSummaryRequest) => {
      const result = await mutation.mutateAsync({
        url: '/user/consumeWrongRoundSummary',
        data,
      })

      queryClient.invalidateQueries({ queryKey: ['wrongRoundSummary'] })

      return result
    },
  }
}
